import { useMemo } from 'react';
import { trpc } from '../lib/trpc';
import { getBrandBadgeClass } from '../lib/brandStyles';

export default function GlobalBrandStyles() {
  const { data: brandColors = {} } = trpc.brandColors.getAll.useQuery();

  const styles = useMemo(() => {
    return Object.values(brandColors)
      .map((color) => {
        const badgeClass = getBrandBadgeClass(color.brand);
        const brandLower = color.brand.toLowerCase();
        const isExcluded = ['hfs', 'homes for students', 'esl', 'essential student living'].includes(brandLower);

        let darkStyles = '';
        if (!isExcluded) {
          darkStyles = `
      .dark .${badgeClass} {
        background-color: color-mix(in srgb, ${color.backgroundColor} 20%, transparent) !important;
        color: color-mix(in srgb, ${color.backgroundColor} 60%, white) !important;
      }`;
        }

        return `
      .${badgeClass} {
        background-color: ${color.backgroundColor} !important;
        color: ${color.textColor} !important;
      }
      ${darkStyles}
    `;
      })
      .join('\n');
  }, [brandColors]);

  if (!styles) return null;

  return <style dangerouslySetInnerHTML={{ __html: styles }} />;
}
